import {eventHandler, listener} from "../../../../modules/vegas/js/util";
import {timeout} from "../../vg/modules/timeout";
import axios from "axios";
import VGDropdown from "../../../../modules/vegas/js/dropdown";

listener('click', '[data-vg-toggle="location-address-lookup"]', function (el, e) {
	let dropElement = el.closest('.vg-dropdown').querySelector('.dropdown-lookup');
	let drop = new VGDropdown(dropElement, {
		backdrop: false,
		overflow: false,
		button: el.closest('.form-floating, .input-group')
	});

	el.value ? drop.show() : drop.hide();
});

listener('click keyup change', '[data-vg-toggle="location-address-lookup"]', function (el, e) {
	let drop = el.closest('.vg-dropdown').querySelector('.dropdown-lookup');

	timeout('location-lookup', 300, () => {
		let route = drop.dataset.routeLookup;
		let query = el.value;
		let containerResult = drop.querySelector('.addresses');
		let containerErrorEmpty = drop.querySelector('.error-empty');
		let addressPrefix = el.dataset.addressPrefix;

		if (addressPrefix && !query.startsWith(addressPrefix)) {
			delete el.dataset.addressPrefix;
			delete el.dataset.addressAfterLevel;
		}

		const dropdown = VGDropdown.getInstance(drop, {
			button: el,
			overflow: false,
			backdrop: false
		});

		let params = {
			query: query,
			after_level: el.dataset.addressAfterLevel,
		};

		if (query) {
			axios.get(route, {params: params})
				.then(response => {
					let focus = el === document.activeElement;
					containerResult.innerHTML = '';
					let waitingForDetail = addressPrefix && query.trim() === addressPrefix;
					containerErrorEmpty.innerText = waitingForDetail
						? (parseInt(el.dataset.addressAfterLevel) === 7 ? 'Введите номер дома' : 'Начните вводить улицу')
						: 'Адрес не найден';

					if (focus && !dropdown._isShow()) {
						dropdown.show();
					}

					if (response.data.addresses.length) {
						containerErrorEmpty.classList.add('d-none');

						containerResult.innerHTML = response.data.addresses.map(function (addr) {
							return `<li><span data-addr data-level="${addr.level}">${addr.value}</span></li>`;
						}).join('');
					} else {
						containerErrorEmpty.classList.remove('d-none');
					}
				});
		} else {
			containerResult.innerHTML = '';

			if (dropdown._isShow()) {
				dropdown.hide();
			}
		}
	});
});

listener('click', '.vg-dropdown .dropdown-lookup [data-addr]', (el, e) => {
	let drop = el.closest('.dropdown-lookup'),
		input = el.closest('.vg-dropdown').querySelector('[data-vg-toggle="location-address-lookup"]'),
		address = el.innerText,
		level = parseInt(el.dataset.level);

	if (!input) return;

	if ([6, 7, 65].includes(level)) {
		input.value = address + ' ';
		input.dataset.addressPrefix = address;
		input.dataset.addressAfterLevel = level;
	} else {
		input.value = address;
		delete input.dataset.addressPrefix;
		delete input.dataset.addressAfterLevel;
	}

	input.focus();
	input.setSelectionRange(1000, 1000);

	eventHandler.on(input, 'change');

	/*if (!drop) return;
	const instance = VGDropdown.getInstance(drop, {
		button: input,
		overflow: false,
		backdrop: false
	});*/

	//instance.toggle();
});
